import { CouponForm, checkValidData } from "components";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import routesMap from "routeControl/userRouteMap";
import { SubscriptionServices } from "services";
import {
  checkValidCount,
  getSessionStorage,
  logger,
  modalNotification,
  setSessionStorage,
} from "utils";

function CouponCode() {
  const subscriptionDatas = getSessionStorage("subscriptionDatas");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const path = {
    1: `${routesMap?.LAYOUTFOUR?.path}/${1}`,
    4: `${routesMap?.LAYOUTFOUR?.path}/${4}`,
    3: routesMap?.LAYOUTTHREE?.path,
  };

  const getSubscription = async () => {
    try {
      const res = await SubscriptionServices.getSubscriptionService();
      const { data, success } = res;
      if (success) {
        navigate(path?.[data?.subscription?.layout]);
        setSessionStorage("oneSubscriptionData", data);
      }
    } catch (error) {
      logger(error);
    }
  };

  const onSubmit = async (item, val) => {
    setSessionStorage("cardData", item);
    try {
      let bodyData = {
        ...val,
        subscriptionId: item?.id,
        amount: item?.amount,
        currency: "usd",
      };
      const res = await SubscriptionServices.createSubscriptionService(
        bodyData
      );
      const { data, success } = res;
      if (success) {
        setSessionStorage("subscriptionData", data);
        let newBodyData = { ...val };
        newBodyData.subscriptionId = data?.userSubscriptionData?.id;
        newBodyData.token = val?.couponCode;
        const newRes = await SubscriptionServices?.checkoutPaymentService(
          newBodyData
        );
        if (newRes?.success) {
          modalNotification({
            type: "success",
            message: newRes?.message,
          });
          getSubscription();
        }
      }
    } catch (error) {
      logger(error);
    }
  };

  return (
    <main className="bg-light-grey paymentPage py-50 pb-0 mainModule">
      <section className="pageTitle">
        <Container>
          {/* <h1 className="fw-semibold">{t("text.payment.payment")}</h1>
          <p className="mb-0">{t("text.payment.completeTransaction")}</p> */}
        </Container>
      </section>
      <section className="py-80 pt-0">
        <Container>
          <Row className="gx-3 gx-xl-4">
            {" "}
            <Col md={8}>
              {" "}
              <div className="paymentPage_card mb-3 mb-xl-4">
                <CouponForm onSubmit={onSubmit} item={subscriptionDatas} />
              </div>
            </Col>
            <Col md={4}>
              <div className="paymentPage_card subscriptionPlan">
                <h2>{t("text.common.orderSummary")}</h2>
                <div className="subscriptionPlan_card subscriptionPlan_card-bggreen  mt-2">
                  <div className="top">
                    <h3 className="fw-semibold">
                      {checkValidData(subscriptionDatas?.name)}
                    </h3>
                    <p className="mb-0 fw-light">
                      {t("text.common.oneTimePayment")}
                    </p>
                  </div>
                  <div className="price ">
                    <h4 className="fw-bold">Enter Code</h4>
                  </div>
                  <ul className="list-unstyled mb-0 subscriptionPlan_card_list pb-0">
                    <li>
                      <div className="d-flex align-items-center">
                        <em className="icon-check" />{" "}
                        {subscriptionDatas?.memorialPage}{" "}
                        {t("text.common.memorialPage")}
                      </div>
                    </li>
                    <li>
                      <div className="d-flex align-items-center">
                        <em className="icon-check" />{" "}
                        {subscriptionDatas?.layout}{" "}
                        {t("text.common.layoutOptions")}
                      </div>
                    </li>
                    <li>
                      <div className="d-flex align-items-center">
                        <em className="icon-check" />{" "}
                        {checkValidCount(subscriptionDatas?.storage)}{" "}
                        {t("text.common.gbStorage")}
                        <span className="text-danger">*</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
}

export default CouponCode;
